import React from 'react';

const CurrentlyWorkingOn: React.FC = () => (
  <section id="currently-working-on">
    <h2>Currently Working On</h2>
    <ul>
      <li>Webcam-based eye tracker</li>
      <li>PowerPoint presentation (professional design)</li>
      <li>Improving AI models for malware detection, seizure prediction, and stock forecasting</li>
    </ul>
  </section>
);

export default CurrentlyWorkingOn;
